<template>
  <div class="lazy-item">
    <slot></slot>
  </div>
</template>

<script>
  export default {
	name: "LazyItem",
	components: {},
	props: {
	  noticeSlot: Boolean
	},
	data() {
	  return {};
	},
	created() {
	  this.parent = this.$utils.findParent(this, "LazyContainer");
	  if (!this.parent) return;
	  this.parent.children.push(this);
	},
	methods: {
	  onVisible() {
		this.$emit("show");
		this.noticeSlot && this.$children.forEach(vm => {
		  vm.visibleStateChange && vm.visibleStateChange('show');
		});
		if (this.hadLoad) return;
		this.hadLoad = true;
		this.$emit('load');
	  },
	  onHidden() {
		this.$emit("hidden");
		this.noticeSlot && this.$children.forEach(vm => {
		  vm.visibleStateChange && vm.visibleStateChange('hidden');
		});
	  },

	  onLeave() {
		this.$emit("leave");
		this.noticeSlot && this.$children.forEach(vm => {
		  vm.visibleStateChange && vm.visibleStateChange('leave');
		});
	  },

	  onReachTop() {
		this.$emit("reach-top");
		this.noticeSlot && this.$children.forEach(vm => {
		  vm.visibleStateChange && vm.visibleStateChange('reachTop');
		});
	  },

	  onReachBottom() {
		this.$emit("reach-bottom");
		this.noticeSlot && this.$children.forEach(vm => {
		  vm.visibleStateChange && vm.visibleStateChange('reachBottom');
		});
	  },
	},
	computed: {}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .lazy-item {
  }
</style>
